import { useMemo } from 'react'
import panelShineLandscape from '@assets/jackpot-eq/panel-shine-l.png'
import panelShineGoldPlatinumPortrait from '@assets/jackpot-eq/panel-shine-gold-platinum-p.png'
import panelShineSilverBronzePortrait from '@assets/jackpot-eq/panel-shine-silver-bronze-p.png'
import panelShineDesktop from '@assets/jackpot-eq/panel-shine-desktop.png'
import { useConfigurationStore } from '@stores'
import { JackpotEQLevels, ViewportType } from 'game-ui-types'

type ShineConfig = {
    width: number
    height: number
    frameCount: number
    backgroundImage: string
}

type PanelType = 'desktop' | 'landscape' | 'goldPlatinumPortrait' | 'silverBronzePortrait'

const configs: Record<PanelType, ShineConfig> = {
    desktop: {
        width: 348,
        height: 83,
        frameCount: 45,
        backgroundImage: panelShineDesktop,
    },
    landscape: {
        width: 260,
        height: 62,
        frameCount: 45,
        backgroundImage: panelShineLandscape,
    },
    goldPlatinumPortrait: {
        width: 330,
        height: 72,
        frameCount: 45,
        backgroundImage: panelShineGoldPlatinumPortrait,
    },
    silverBronzePortrait: {
        width: 242,
        height: 62,
        frameCount: 45,
        backgroundImage: panelShineSilverBronzePortrait,
    },
}

const JackpotStatisticsEQShining = ({ type }: { type: JackpotEQLevels }) => {
    const viewport = useConfigurationStore((state) => state.viewport)

    const config = useMemo(() => {
        if (viewport === ViewportType.MOBILE_LANDSCAPE) {
            return configs.landscape
        }

        if (viewport === ViewportType.DESKTOP) {
            return configs.desktop
        }

        const configPortrait =
            type === JackpotEQLevels.BRONZE || type === JackpotEQLevels.SILVER
                ? configs.silverBronzePortrait
                : configs.goldPlatinumPortrait

        return configPortrait
    }, [viewport, type])

    const totalWidth = -(config.frameCount * config.width)
    const animationName = 'play-shine'

    const styleTag = `
    @keyframes ${animationName} {
      0%   { background-position: 0px 0; }
      100% { background-position: ${totalWidth}px 0; }
    }
  `

    return (
        <>
            <style>{styleTag}</style>
            <div
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    pointerEvents: 'none',
                }}
            >
                <div
                    style={{
                        width: `${config.width}px`,
                        height: `${config.height}px`,
                        backgroundImage: `url(${config.backgroundImage})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: '0 0',
                        animation: `${animationName} 1.4s steps(${config.frameCount}) infinite`,
                    }}
                />
            </div>
        </>
    )
}

export default JackpotStatisticsEQShining
